import { CommonModule } from "@angular/common";
import { Component, Inject, TemplateRef, ViewChild } from "@angular/core";
import {
  ReactiveFormsModule,
  FormsModule,
  FormControl,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialog,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  OrderAttributes,
  OrderDetailAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { MatSnackBar } from "@angular/material/snack-bar";
import { IUpdateOrder } from "../update-order/interfaces/update-order.interface";
import { UpdateOrderService } from "../update-order/update-order.service";
import ReasonRejectionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/reason-rejection/reason-rejection.entity";
import { ReasonRejectionService } from "../../master/reason-for-rejection/reason-rejection.service";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';

@Component({
  selector: "app-cancel-order-modal",
  styleUrl: "./cancel-order.component.scss",
  templateUrl: "./cancel-order.component.html",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatSelectModule,
  ],
})
export class CancelOrderComponent {
  isLoading: boolean = false;

  reasonRejectionControl = new FormControl(null, Validators.required);
  reasonRejectionRequired: boolean = true;
  reasonRejectionDisabled: boolean = false;
  reasonRejectionList: ReasonRejectionAttributes[] = [];
  filteredReasonRejectionList = this.reasonRejectionList;
  searchReasonRejection: string = null;

  @ViewChild("orderConfirmationDialog")
  orderConfirmationDialog!: TemplateRef<any>;

  constructor(
    private readonly updateOrderService: UpdateOrderService,
    private readonly reasonRejectionService: ReasonRejectionService,
    public readonly dialogRef: MatDialogRef<CancelOrderComponent>,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      type: "ORDER" | "DETAIL";
      order: OrderAttributes;
      orderDetail?: OrderDetailAttributes;
    }
  ) {}

  ngAfterViewInit(): void {
    this.fetchReasonRejections();
  }

  fetchReasonRejections() {
    this.reasonRejectionService.findToComboBox().subscribe({
      next: (res) => {
        this.reasonRejectionList = res.data;
        this.filteredReasonRejectionList = this.reasonRejectionList;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener los motivos de cancelación.",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  filterReasonRejections() {
    const filterValue = this.searchReasonRejection.toLowerCase();
    this.filteredReasonRejectionList = this.reasonRejectionList.filter((e) =>
      e.name.toLowerCase().includes(filterValue)
    );
  }

  openConfirmationDialog(): void {
    this.dialog
      .open(this.orderConfirmationDialog, {
        data: { type: this.data.type },
        panelClass: "form-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.onSave());
  }

  onSave(): void {
    this.isLoading = true;
    const dataToUpdate: IUpdateOrder = {};
    if (this.data.type == "ORDER") {
      dataToUpdate.reasonForRejection = this.reasonRejectionControl.value;
      dataToUpdate.statusId = StatusEnum.INACTIVE;
    } else {
      dataToUpdate.detail = [
        {
          position: this.data.orderDetail.position,
          reasonForRejection: this.reasonRejectionControl.value,
          statusId: StatusEnum.INACTIVE,
        },
      ];
    }

    this.updateOrderService
      .updateOrder(String(this.data.order._id), dataToUpdate)
      .subscribe({
        next: (res) => {
          this.snackBar.open(
            this.data.type == "ORDER"
              ? this.data.order.type.code == DocumentTypeEnum.COTIZACION
                ? "Cotización anulada con éxito."
                : "Pedido anulado con éxito."
              : "Detalle eliminado con éxito.",
            "Cerrar",
            {
              duration: 3000,
            }
          );
          this.isLoading = false;
          this.dialogRef.close(res);
        },
        error: (err) => {
          this.isLoading = false;
          this.snackBar.open(
            err.error.message ||
              (this.data.type == "ORDER"
                ? this.data.order.type.code == DocumentTypeEnum.COTIZACION
                  ? "Error al anular la cotización."
                  : "Error al anular el pedido."
                : "Error al eliminar el detalle."),
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }
}
